class TechStackMarquee extends HTMLElement {
  connectedCallback() {
    this.rows = this.querySelectorAll('.tstack__row-inner');
    if (!this.rows.length) return;

    this._activeIcon = null;
    this._pausedRow = null;
    this._tooltip = this.querySelector('.tstack__tooltip');

    window.addEventListener('resize', this._onResize.bind(this));
    this.addEventListener('click', this._onClick.bind(this));
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this._reset();
    });

    requestAnimationFrame(() => {
      this.rows.forEach((row) => this._fillRow(row));
      this.rows.forEach((row) => this._duplicateRow(row));
      this._setSpeed();
      this.setAttribute('data-ready', '');
    });
  }

  _onClick(e) {
    const icon = e.target.closest('.tstack__icon');
    if (!icon) return;

    const name = icon.getAttribute('data-name');
    if (!name) return;

    const row = icon.closest('.tstack__row');

    // Clicking the same icon — toggle off
    if (this._activeIcon === icon) {
      this._reset();
      return;
    }

    // Reset previous state
    this._reset();

    // Activate
    this._activeIcon = icon;
    this._pausedRow = row;
    icon.setAttribute('data-active', '');
    row.setAttribute('data-paused', '');

    // Position tooltip
    if (this._tooltip) {
      this._tooltip.textContent = name;
      this._tooltip.classList.add('tstack__tooltip--visible');

      const iconRect = icon.getBoundingClientRect();
      const parentRect = this.getBoundingClientRect();
      this._tooltip.style.top = (iconRect.top - parentRect.top - 8) + 'px';
      this._tooltip.style.left = (iconRect.left - parentRect.left + iconRect.width / 2) + 'px';
    }
  }

  _reset() {
    if (this._activeIcon) {
      this._activeIcon.removeAttribute('data-active');
      this._activeIcon = null;
    }
    if (this._pausedRow) {
      this._pausedRow.removeAttribute('data-paused');
      this._pausedRow = null;
    }
    if (this._tooltip) {
      this._tooltip.classList.remove('tstack__tooltip--visible');
    }
  }

  _fillRow(row) {
    const items = row.querySelector('.tstack__row-items');
    if (!items) return;
    const viewportWidth = this.offsetWidth;
    let contentWidth = items.scrollWidth;
    const original = items.innerHTML;
    let copies = 0;
    while (contentWidth < viewportWidth * 2 && copies < 10) {
      items.insertAdjacentHTML('beforeend', original);
      contentWidth = items.scrollWidth;
      copies++;
    }
  }

  _duplicateRow(row) {
    const items = row.querySelector('.tstack__row-items');
    if (!items) return;
    const existingClone = row.querySelector('[aria-hidden="true"]');
    if (existingClone) existingClone.remove();
    const clone = items.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    row.appendChild(clone);
  }

  _setSpeed() {
    const factor = parseFloat(this.getAttribute('data-speed-factor') || '30');
    const factor2 = parseFloat(this.getAttribute('data-speed-factor-row2') || factor);
    this.rows.forEach((row, index) => {
      const items = row.querySelector('.tstack__row-items');
      if (!items) return;
      const width = items.scrollWidth;
      const f = index === 0 ? factor : factor2;
      const speed = Math.max(15, (width / 1000) * f);
      row.style.setProperty('--tstack-speed', `${speed}s`);
    });
  }

  _onResize() {
    clearTimeout(this._resizeTimer);
    this._resizeTimer = setTimeout(() => {
      this._reset();
      this.rows.forEach((row) => {
        const items = row.querySelector('.tstack__row-items');
        if (!items) return;
        const originalCount = parseInt(items.getAttribute('data-original-count') || items.children.length);
        while (items.children.length > originalCount) {
          items.lastElementChild.remove();
        }
        this._fillRow(row);
        this._duplicateRow(row);
      });
      this._setSpeed();
    }, 250);
  }
}

if (!customElements.get('tech-stack-marquee')) {
  customElements.define('tech-stack-marquee', TechStackMarquee);
}
